import { defineComponent as _defineComponent } from 'vue';
import ExternalLink from "@/components/ExternalLink.vue";
import Heading from "@/components/Common/Heading.vue";
import Abbreviation from "@/components/Common/Abbreviation.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CarbonEmissionsCalculations',
    setup(__props) {
        const dictionary = [
            {
                term: "TDP (Thermal Design Power)",
                definition: "The maximum amount of heat a CPU can produce in Watts. This correlates with power usage.",
            },
            {
                term: "PUE (Power Usage Effectiveness)",
                definition: "A measure of how of much energy a data center running your server uses.",
            },
            {
                term: "Carbon Intensity",
                definition: "The amount greenhouse gases emitted per unit of electricity produced.",
            },
            {
                term: "AWS EC2",
                definition: "An Amazon service allowing users to rent virtual computers and deploy their own web services.",
            },
            {
                term: "CO2e",
                definition: "Other types of greenhouse gases that have similar global warming potential as a metric unit amount of CO2 itself.",
            },
        ];
        const epaUrl = "https://www.epa.gov/energy/greenhouse-gas-equivalencies-calculator";
        const epaCalculationsUrl = "https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references";
        const greenAlgorithmsUrl = "https://www.green-algorithms.org/";
        return { __sfc: true, dictionary, epaUrl, epaCalculationsUrl, greenAlgorithmsUrl, ExternalLink, Heading, Abbreviation };
    }
});
